import { useState } from "react";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { Stack, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";

const BlackListDialog = ({ open, setOpen }) => {
    const { bt } = useBizTypeTranslation();

    const onClose = () => { setOpen(false) };

    return (
        <CustomDialog open={open} onClose={onClose} title='BLACK_LIST_DIALOG'>
            <Stack alignItems='center' spacing={1}>
                <Stack alignItems='center'>
                    <Typography fontWeight='bold' color='error.text'>לצערנו המשתמש שלך נחסם</Typography>
                    <Typography fontWeight='bold' color='error.text'>עקב מספר ניסיונות רב</Typography>
                </Stack>
                <Stack alignItems='center'>
                    <Typography>לביטול החסימה יש לפנות לשרות לקוחות:</Typography>
                    <Typography>טלפון: 077-505-4041</Typography>
                    <Typography>הודעת ווצאפ: 077-505-4041</Typography>
                    <Typography>דוא"ל: support@mybee.co.il</Typography>
                </Stack>
                <Typography variant="h6" fontWeight='bold'>יש להכין מזהה עסק לצורך אימות</Typography>
            </Stack>
        </CustomDialog>
    );
};
export default BlackListDialog;